export default __webpack_public_path__ + "static/media/apple.f53ca10e.svg";